//缺7、长条夹  
import makerjs from "makerjs";
// 矩形等去角 连线函数
function creatmyLongClipGap(area, param) {
  console.log("是否调用此函数creatOneCorner（）");
  console.log("是否调用此函数creatOneCorner（）param=", param);
  var xa = param.xa, ya = param.ya, xb = param.xb, 
  yb = param.yb, xc = param.xc, cutLine=param.cutLine,cutFilletRadius=param.cutFilletRadius,
  xd = param.xd, yd = param.yd, xf = param.xf, yf = param.yf,glassH=param.glassH,glassW=param.glassW, 
  yc = param.yc, xg = param.xg, yg = param.yg, 
  xh = param.xh, yh = param.yh, xi = param.xi, yi = param.yi, 
  x = param.x0, r = param.r, d = param.d,r1 = param.r1,d1 = param.d1, h = param.h,h1 = param.h1; 
if(glassW*1>glassH * 1){
      console.log("长边在X轴￥￥￥￥￥");
      if (area == "A") {
            var myLongClipGap = {
              paths: {
                "LeftLine": new makerjs.paths.Line([xa, ya], [xa, ya-h]),
                "BottomArc": new makerjs.paths.Arc([xa, ya-h], [xa+d, ya-h],r,false,false),
                "RightLine": new makerjs.paths.Line([xa+d, ya-h], [xa+d, ya]),
                "BottomCircle": new makerjs.paths.Circle([xa+d/2, ya-h1],r1),
                  }
            };
            var myLongClipGapWaterCut = {
              paths: {
                "EnLine": new makerjs.paths.Line([xa, ya+cutLine], [xa, ya]),
                "LeftLine": new makerjs.paths.Line([xa, ya], [xa, ya-h]),
                "BottomArcLf": new makerjs.paths.Arc([xa, ya-h], [xa+d/2, ya-h-d/2],r,false,false),
                "slotLineLf": new makerjs.paths.Line([xa+d/2, ya-h-d/2], [xa+d/2, ya-h1+r1]),
                "BottomCircleLf": new makerjs.paths.Arc([xa+d/2, ya-h1+r1], [xa+d/2, ya-h1-r1],r1,false,false),
                "BottomCircleRt": new makerjs.paths.Arc([xa+d/2, ya-h1-r1], [xa+d/2, ya-h1+r1],r1,false,false),
                "slotLineRt": new makerjs.paths.Line([xa+d/2, ya-h1+r1], [xa+d/2, ya-h-d/2]),
                "BottomArcRt": new makerjs.paths.Arc([xa+d/2, ya-h-d/2], [xa+d, ya-h],r,false,false),
                "RightLine": new makerjs.paths.Line([xa+d, ya-h], [xa+d, ya]),
                "ExLine": new makerjs.paths.Line([xa+d, ya], [xa+d, ya+cutLine]),
                  }
            };      
            var fillet1 = makerjs.path.fillet(myLongClipGapWaterCut.paths.BottomArcLf, myLongClipGapWaterCut.paths.slotLineLf, cutFilletRadius);
            var fillet2 = makerjs.path.fillet(myLongClipGapWaterCut.paths.slotLineLf, myLongClipGapWaterCut.paths.BottomCircleLf, cutFilletRadius);
            var fillet3 = makerjs.path.fillet(myLongClipGapWaterCut.paths.BottomCircleRt, myLongClipGapWaterCut.paths.slotLineRt, cutFilletRadius);
            var fillet4 = makerjs.path.fillet(myLongClipGapWaterCut.paths.slotLineRt, myLongClipGapWaterCut.paths.BottomArcRt, cutFilletRadius);
            myLongClipGapWaterCut.paths.fillet1 = fillet1;
            myLongClipGapWaterCut.paths.fillet2 = fillet2;
            myLongClipGapWaterCut.paths.fillet3 = fillet3;
            myLongClipGapWaterCut.paths.fillet4 = fillet4;
          } else if (area == "B") {
            var myLongClipGap = {
                  paths: {
                    "LeftLine": new makerjs.paths.Line([xb-r, yb], [xb-r, yb-h]),
                    "BottomArc": new makerjs.paths.Arc([xb-r, yb-h], [xb+d-r, yb-h],r,false,false),
                    "RightLine": new makerjs.paths.Line([xb+d-r, yb-h], [xb+d-r, yb]),
                    "BottomCircle": new makerjs.paths.Circle([xb+d/2-r, yb-h1-r],r1),
                      }
                };
                var myLongClipGapWaterCut = {
                      paths: {
                        "EnLine": new makerjs.paths.Line([xb-r, yb+cutLine], [xb-r, yb]),
                        "LeftLine": new makerjs.paths.Line([xb-r, yb], [xb-r, yb-h]),
                        "BottomArcLf": new makerjs.paths.Arc([xb-r, yb-h], [xb, yb-h-d/2],r,false,false),
                        "slotLineLf": new makerjs.paths.Line([xb, yb-h-d/2], [xb, yb-h1+r1]),
                        "BottomCircleLf": new makerjs.paths.Arc([xb, yb-h1+r1], [xb, yb-h1-r1],r1,false,false),
                        "BottomCircleRt": new makerjs.paths.Arc([xb, yb-h1-r1], [xb, yb-h1+r1],r1,false,false),
                        "slotLineRt": new makerjs.paths.Line([xb, yb-h1+r1], [xb, yb-h-d/2]),
                        "BottomArcRt": new makerjs.paths.Arc([xb, yb-h-d/2], [xb+r, yb-h],r,false,false),
                        "RightLine": new makerjs.paths.Line([xb+r, yb-h], [xb+r, yb]),
                        "ExLine": new makerjs.paths.Line([xb+r, yb], [xb+r, yb+cutLine]),
                          }
                    };      
                    var fillet1 = makerjs.path.fillet(myLongClipGapWaterCut.paths.BottomArcLf, myLongClipGapWaterCut.paths.slotLineLf, cutFilletRadius);
                    var fillet2 = makerjs.path.fillet(myLongClipGapWaterCut.paths.slotLineLf, myLongClipGapWaterCut.paths.BottomCircleLf, cutFilletRadius);
                    var fillet3 = makerjs.path.fillet(myLongClipGapWaterCut.paths.BottomCircleRt, myLongClipGapWaterCut.paths.slotLineRt, cutFilletRadius);
                    var fillet4 = makerjs.path.fillet(myLongClipGapWaterCut.paths.slotLineRt, myLongClipGapWaterCut.paths.BottomArcRt, cutFilletRadius);
                    myLongClipGapWaterCut.paths.fillet1 = fillet1;
                    myLongClipGapWaterCut.paths.fillet2 = fillet2;
                    myLongClipGapWaterCut.paths.fillet3 = fillet3;
                    myLongClipGapWaterCut.paths.fillet4 = fillet4;
          } else if (area == "C") {
            var myLongClipGap = {
                  paths: {
                    "LeftLine": new makerjs.paths.Line([xc, yc], [xc, yc-h]),
                    "BottomArc": new makerjs.paths.Arc([xc, yc-h], [xc-d, yc-h],r,false,true),
                    "RightLine": new makerjs.paths.Line([xc-d, yc-h], [xc-d, yc]),
                    "BottomCircle": new makerjs.paths.Circle([xc-d/2, yc-h1],r1),
                      }
                };
                var myLongClipGapWaterCut = {
                      paths: {
                        "EnLine": new makerjs.paths.Line([xc, yc+cutLine], [xc, yc]),
                        "LeftLine": new makerjs.paths.Line([xc, yc], [xc, yc-h]),
                        "BottomArcLf": new makerjs.paths.Arc([xc, yc-h], [xc-d/2, yc-h-d/2],r,false,true),
                        "slotLineLf": new makerjs.paths.Line([xc-d/2, yc-h-d/2], [xc-d/2, yc-h1+r1]),
                        "BottomCircleLf": new makerjs.paths.Arc([xc-d/2, yc-h1+r1], [xc-d/2, yc-h1-r1],r1,false,true),
                        "BottomCircleRt": new makerjs.paths.Arc([xc-d/2, yc-h1-r1], [xc-d/2, yc-h1+r1],r1,false,true),
                        "slotLineRt": new makerjs.paths.Line([xc-d/2, yc-h1+r1], [xc-d/2, yc-h-d/2]),
                        "BottomArcRt": new makerjs.paths.Arc([xc-d/2, yc-h-d/2], [xc-d, yc-h],r,false,true),
                        "RightLine": new makerjs.paths.Line([xc-d, yc-h], [xc-d, yc]),
                        "ExLine": new makerjs.paths.Line([xc-d, yc], [xc-d, yc+cutLine]),
                          }
                    };       
                    var fillet1 = makerjs.path.fillet(myLongClipGapWaterCut.paths.BottomArcLf, myLongClipGapWaterCut.paths.slotLineLf, cutFilletRadius);
                    var fillet2 = makerjs.path.fillet(myLongClipGapWaterCut.paths.slotLineLf, myLongClipGapWaterCut.paths.BottomCircleLf, cutFilletRadius);
                    var fillet3 = makerjs.path.fillet(myLongClipGapWaterCut.paths.BottomCircleRt, myLongClipGapWaterCut.paths.slotLineRt, cutFilletRadius);
                    var fillet4 = makerjs.path.fillet(myLongClipGapWaterCut.paths.slotLineRt, myLongClipGapWaterCut.paths.BottomArcRt, cutFilletRadius);
                    myLongClipGapWaterCut.paths.fillet1 = fillet1;
                    myLongClipGapWaterCut.paths.fillet2 = fillet2;
                    myLongClipGapWaterCut.paths.fillet3 = fillet3;
                    myLongClipGapWaterCut.paths.fillet4 = fillet4;
          } else if (area == "G") {
            var myLongClipGap = {
                  paths: {
                    "LeftLine": new makerjs.paths.Line([xg, yg], [xg, yg+h]),
                    "TopArc": new makerjs.paths.Arc([xg, yg+h], [xg+d, yg+h],r,false,true),
                    "RightLine": new makerjs.paths.Line([xg+d, yg+h], [xg+d, yg]),
                    "TopCircle": new makerjs.paths.Circle([xg+d/2, yg+h1],r1),
                      }
                };
                var myLongClipGapWaterCut = {
                      paths: {
                        "EnLine": new makerjs.paths.Line([xg, yg-cutLine], [xg, yg]),
                        "LeftLine": new makerjs.paths.Line([xg, yg], [xg, yg+h]),
                        "TopArcLf": new makerjs.paths.Arc([xg, yg+h], [xg+r, yg+h+r],r,false,true),
                        "slotLineLf": new makerjs.paths.Line([xg+r, yg+h+r], [xg+r, yg+h1-r1]),
                        "TopCircleLf": new makerjs.paths.Arc([xg+r, yg+h1-r1], [xg+r, yg+h1+r1],r1,false,true),
                        "TopCircleRt": new makerjs.paths.Arc([xg+r, yg+h1+r1],[xg+r, yg+h1-r1],r1,false,true),
                        "slotLineRt": new makerjs.paths.Line([xg+r, yg+h1-r1], [xg+r, yg+h+r]),
                        "TopArcRt": new makerjs.paths.Arc([xg+r, yg+h+r], [xg+d, yg+h],r,false,true),
                        "RightLine": new makerjs.paths.Line([xg+d, yg+h], [xg+d, yg]),
                        "ExLine": new makerjs.paths.Line([xg+d, yg], [xg+d, yg-cutLine]),
                          }
                    };                   
                  var fillet1 = makerjs.path.fillet(myLongClipGapWaterCut.paths.TopArcLf, myLongClipGapWaterCut.paths.slotLineLf, cutFilletRadius);
                  var fillet2 = makerjs.path.fillet(myLongClipGapWaterCut.paths.slotLineLf, myLongClipGapWaterCut.paths.TopCircleLf, cutFilletRadius);
                  var fillet3 = makerjs.path.fillet(myLongClipGapWaterCut.paths.TopCircleRt, myLongClipGapWaterCut.paths.slotLineRt, cutFilletRadius);
                  var fillet4 = makerjs.path.fillet(myLongClipGapWaterCut.paths.slotLineRt, myLongClipGapWaterCut.paths.TopArcRt, cutFilletRadius);
                  myLongClipGapWaterCut.paths.fillet1 = fillet1;
                  myLongClipGapWaterCut.paths.fillet2 = fillet2;
                  myLongClipGapWaterCut.paths.fillet3 = fillet3;
                  myLongClipGapWaterCut.paths.fillet4 = fillet4;
          } else if (area == "H") {
            var myLongClipGap = {
                  paths: {
                      "LeftLine": new makerjs.paths.Line([xh-r, yh], [xh-r, yh+h]),
                      "TopArc": new makerjs.paths.Arc([xh-r, yh+h], [xh+d-r, yh+h],r,false,true),
                      "RightLine": new makerjs.paths.Line([xh+d-r, yh+h], [xh+d-r, yh]),
                      "TopCircle": new makerjs.paths.Circle([xh, yh+h1],r1),
                      }
                };          
                var myLongClipGapWaterCut = {
                      paths: {
                          "EnLine": new makerjs.paths.Line([xh-r, yh-cutLine], [xh-r, yh]),
                          "LeftLine": new makerjs.paths.Line([xh-r, yh], [xh-r, yh+h]),
                          "TopArcLf": new makerjs.paths.Arc([xh-r, yh+h], [xh, yh+h+r],r,false,true),
                          "slotLineLf": new makerjs.paths.Line([xh, yh+h+r], [xh, yh+h1-r1]),
                          "TopCircleLf": new makerjs.paths.Arc([xh, yh+h1-r1], [xh, yh+h1+r1],r1,false,true),
                          "TopCircleRt": new makerjs.paths.Arc([xh, yh+h1+r1],[xh, yh+h1-r1],r1,false,true),
                          "slotLineRt": new makerjs.paths.Line([xh, yh+h1-r1], [xh, yh+h+r]),
                          "TopArcRt": new makerjs.paths.Arc([xh, yh+h+r], [xh+d-r, yh+h],r,false,true),
                          "RightLine": new makerjs.paths.Line([xh+d-r, yh+h], [xh+d-r, yh]),
                          "ExLine": new makerjs.paths.Line([xh+d-r, yh], [xh+d-r, yh-cutLine]),
                          }
                    };                                     
                  var fillet1 = makerjs.path.fillet(myLongClipGapWaterCut.paths.TopArcLf, myLongClipGapWaterCut.paths.slotLineLf, cutFilletRadius);
                  var fillet2 = makerjs.path.fillet(myLongClipGapWaterCut.paths.slotLineLf, myLongClipGapWaterCut.paths.TopCircleLf, cutFilletRadius);
                  var fillet3 = makerjs.path.fillet(myLongClipGapWaterCut.paths.TopCircleRt, myLongClipGapWaterCut.paths.slotLineRt, cutFilletRadius);
                  var fillet4 = makerjs.path.fillet(myLongClipGapWaterCut.paths.slotLineRt, myLongClipGapWaterCut.paths.TopArcRt, cutFilletRadius);
                  myLongClipGapWaterCut.paths.fillet1 = fillet1;
                  myLongClipGapWaterCut.paths.fillet2 = fillet2;
                  myLongClipGapWaterCut.paths.fillet3 = fillet3;
                  myLongClipGapWaterCut.paths.fillet4 = fillet4;
          } else if (area == "I") {
           var myLongClipGap = {
              paths: {
                "LeftLine": new makerjs.paths.Line([xi, yi], [xi, yi+h]),
                "TopArc": new makerjs.paths.Arc([xi, yi+h], [xi-d, yi+h],r,false,false),
                "RightLine": new makerjs.paths.Line([xi-d, yi+h], [xi-d, yi]),
                "TopCircle": new makerjs.paths.Circle([xi-d/2, yi+h1],r1),
              }
        };
      //   var myLongClipGap = {
      //       paths: {
      //         "LeftLine": new makerjs.paths.Line([xi, yi], [xi, yi+h]),
      //         "TopArc": new makerjs.paths.Arc([xi, yi+h], [xi-d, yi+h],r,false,false),
      //         "RightLine": new makerjs.paths.Line([xi-d, yi+h], [xi-d, yi]),
      //         "TopCircle": new makerjs.paths.Circle([xi-d/2, yi+h1],r1),
      //       }
      // };
      var myLongClipGapWaterCut = {
         paths: {
            "EnLine": new makerjs.paths.Line([xi, yi-cutLine], [xi, yi]),
           "LeftLine": new makerjs.paths.Line([xi, yi], [xi, yi+h]),
           "TopArcLf": new makerjs.paths.Arc([xi, yi+h], [xi-d/2, yi+h+r],r,false,false),
           "slotLineLf": new makerjs.paths.Line([xi-d/2, yi+h+r], [xi-d/2, yi+h1-r1]),
           "TopCircleLf": new makerjs.paths.Arc([xi-d/2, yi+h1-r1],[xi-d/2, yi+h1+r1],r1,false,false),
           "TopCircleRt": new makerjs.paths.Arc([xi-d/2, yi+h1+r1],[xi-d/2, yi+h1-r1],r1,false,false),
           "slotLineRt": new makerjs.paths.Line([xi-d/2, yi+h1-r1], [xi-d/2, yi+h+r]),
           "TopArcRt": new makerjs.paths.Arc([xi-d/2, yi+h+r], [xi-d, yi+h],r,false,false),
           "RightLine": new makerjs.paths.Line([xi-d, yi+h], [xi-d, yi]),
           "ExLine": new makerjs.paths.Line([xi-d, yi], [xi-d, yi-cutLine]),
         }
   };                                
  var fillet1 = makerjs.path.fillet(myLongClipGapWaterCut.paths.TopArcLf, myLongClipGapWaterCut.paths.slotLineLf, cutFilletRadius);
  var fillet2 = makerjs.path.fillet(myLongClipGapWaterCut.paths.slotLineLf, myLongClipGapWaterCut.paths.TopCircleLf, cutFilletRadius);
  var fillet3 = makerjs.path.fillet(myLongClipGapWaterCut.paths.TopCircleRt, myLongClipGapWaterCut.paths.slotLineRt, cutFilletRadius);
  var fillet4 = makerjs.path.fillet(myLongClipGapWaterCut.paths.slotLineRt, myLongClipGapWaterCut.paths.TopArcRt, cutFilletRadius);
  myLongClipGapWaterCut.paths.fillet1 = fillet1;
  myLongClipGapWaterCut.paths.fillet2 = fillet2;
  myLongClipGapWaterCut.paths.fillet3 = fillet3;
  myLongClipGapWaterCut.paths.fillet4 = fillet4;


          }
}else{
      console.log("短边在X轴￥￥￥￥￥");
         if (area == "A") {
            var myLongClipGap = {
              paths: {
                "LeftLine": new makerjs.paths.Line([xa, ya], [xa+h, ya]),
                "BottomArc": new makerjs.paths.Arc([xa+h, ya], [xa+h, ya-d],r,false,true),
                "RightLine": new makerjs.paths.Line([xa+h, ya-d], [xa, ya-d]),
                "BottomCircle": new makerjs.paths.Circle([xa+h1, ya-d/2],r1),
                  }
            };
            var myLongClipGapWaterCut = {
              paths: {
                "EnLine": new makerjs.paths.Line([xa-cutLine, ya], [xa, ya]),
                "LeftLine": new makerjs.paths.Line([xa, ya], [xa+h, ya]),
                "BottomArcLf": new makerjs.paths.Arc([xa+h, ya], [xa+h+r, ya-d/2],r,false,true),
                "slotLineLf": new makerjs.paths.Line([xa+h+r, ya-d/2], [xa+h1-r1, ya-d/2]),
                "BottomCircleLf": new makerjs.paths.Arc([xa+h1-r1, ya-d/2],[xa+h1+r1, ya-d/2],r1,false,true),
                "BottomCircleRt": new makerjs.paths.Arc([xa+h1+r1, ya-d/2],[xa+h1-r1, ya-d/2],r1,false,true),
                "slotLineRt": new makerjs.paths.Line([xa+h1-r1, ya-d/2], [xa+h+r, ya-d/2]),
                "BottomArcRt": new makerjs.paths.Arc([xa+h+r, ya-d/2], [xa+h, ya-d],r,false,true),
                "RightLine": new makerjs.paths.Line([xa+h, ya-d], [xa, ya-d]),
                "ExLine": new makerjs.paths.Line([xa, ya-d], [xa-cutLine, ya-d]),
                  }
            };
             
          } else if (area == "D") {
              var myLongClipGap = {
                    paths: {
                        "LeftLine": new makerjs.paths.Line([xd, yd+d/2], [xd+h, yd+d/2]),
                        "BottomArc": new makerjs.paths.Arc([xd+h, yd+d/2], [xd+h, yd-d/2],r,false,true),
                        "RightLine": new makerjs.paths.Line([xd+h, yd-d/2], [xd, yd-d/2]),
                        "BottomCircle": new makerjs.paths.Circle([xd+h1, yd],r1),
                        }
                  };
                  var myLongClipGapWaterCut = {
                    paths: {
                      "EnLine": new makerjs.paths.Line([xd-cutLine, yd+d/2], [xd, yd+d/2]),
                      "LeftLine": new makerjs.paths.Line([xd, yd+d/2], [xd+h, yd+d/2]),
                      "BottomArcLf": new makerjs.paths.Arc([xd+h, yd+d/2], [xd+h+r, yd],r,false,true),
                      "slotLineLf": new makerjs.paths.Line([xd+h+r, yd], [xd+h1-r1, yd]),
                      "BottomCircleLf": new makerjs.paths.Arc([xd+h1-r1, yd],[xd+h1+r1, yd],r1,false,true),
                      "BottomCircleRt": new makerjs.paths.Arc([xd+h1+r1, yd],[xd+h1-r1, yd],r1,false,true),
                      "slotLineRt": new makerjs.paths.Line([xd+h1-r1, yd], [xd+h+r, yd]),
                      "BottomArcRt": new makerjs.paths.Arc([xd+h+r, yd], [xd+h, yd-d/2],r,false,true),
                      "RightLine": new makerjs.paths.Line([xd+h, yd-d/2], [xd, yd-d/2]),
                      "ExLine": new makerjs.paths.Line([xd, yd-d/2], [xd-cutLine, yd-d/2]),
                        }
                  };
          } else if (area == "G") {
            var myLongClipGap = {
                  paths: {
                      "LeftLine": new makerjs.paths.Line([xg, yg], [xg+h, yg]),
                      "BottomArc": new makerjs.paths.Arc([xg+h, yg], [xg+h, yg+d],r,false,false),
                      "RightLine": new makerjs.paths.Line([xg+h, yg+d], [xg, yg+d]),
                      "BottomCircle": new makerjs.paths.Circle([xg+h1, yg+d/2],r1),
                      }
                };
                var myLongClipGapWaterCut = {
                  paths: {
                    "EnLine": new makerjs.paths.Line([xg-cutLine, yg], [xg, yg]),
                    "LeftLine": new makerjs.paths.Line([xg, yg], [xg+h, yg]),
                    "BottomArcLf": new makerjs.paths.Arc([xg+h, yg], [xg+h+r, yg+d/2],r,false,false),
                    "slotLineLf": new makerjs.paths.Line([xg+h+r, yg+d/2], [xg+h1-r1, yg+d/2]),
                    "BottomCircleLf": new makerjs.paths.Arc([xg+h1-r1, yg+d/2],[xg+h1+r1, yg+d/2],r1,false,false),
                    "BottomCircleRt": new makerjs.paths.Arc([xg+h1+r1, yg+d/2],[xg+h1-r1, yg+d/2],r1,false,false),
                    "slotLineRt": new makerjs.paths.Line([xg+h1-r1, yg+d/2], [xg+h+r, yg+d/2]),
                    "BottomArcRt": new makerjs.paths.Arc([xg+h+r, yg+d/2], [xg+h, yg+d],r,false,false),
                    "RightLine": new makerjs.paths.Line([xg+h, yg+d], [xg, yg+d]),
                    "ExLine": new makerjs.paths.Line([xg, yg+d], [xg-cutLine, yg+d]),
                      }
                };
          } else if (area == "C") {
            var myLongClipGap = {
                  paths: {
                      "LeftLine": new makerjs.paths.Line([xc, yc], [xc-h, yc]),
                      "BottomArc": new makerjs.paths.Arc([xc-h, yc], [xc-h, yc-d],r,false,false),
                      "RightLine": new makerjs.paths.Line([xc-h, yc-d], [xc, yc-d]),
                      "BottomCircle": new makerjs.paths.Circle([xc-h1, yc-d/2],r1),
                      }
                };
                var myLongClipGapWaterCut = {
                  paths: {
                    "EnLine": new makerjs.paths.Line([xc+cutLine, yc], [xc, yc]),
                    "LeftLine": new makerjs.paths.Line([xc, yc], [xc-h, yc]),
                    "BottomArcLf": new makerjs.paths.Arc([xc-h, yc], [xc-h-r, yc-d/2],r,false,false),
                    "slotLineLf": new makerjs.paths.Line([xc-h-r, yc-d/2], [xc-h1+r1, yc-d/2]),
                    "BottomCircleLf": new makerjs.paths.Arc([xc-h1+r1, yc-d/2],[xc-h1-r1, yc-d/2],r1,false,false),
                    "BottomCircleRt": new makerjs.paths.Arc([xc-h1-r1, yc-d/2],[xc-h1+r1, yc-d/2],r1,false,false),
                    "slotLineRt": new makerjs.paths.Line([xc-h1+r1, yc-d/2], [xc-h-r, yc-d/2]),
                    "BottomArcRt": new makerjs.paths.Arc([xc-h-r, yc-d/2], [xc-h, yc-d],r,false,false),
                    "RightLine": new makerjs.paths.Line([xc-h, yc-d], [xc, yc-d]),
                    "ExLine": new makerjs.paths.Line([xc, yc-d], [xc+cutLine, yc-d]),
                      }
                };
          } else if (area == "F") {
            var myLongClipGap = {
                  paths: {
                        "LeftLine": new makerjs.paths.Line([xf, yf+d/2], [xf-h, yf+d/2]),
                        "BottomArc": new makerjs.paths.Arc([xf-h, yf+d/2], [xf-h, yf-d/2],r,false,false),
                        "RightLine": new makerjs.paths.Line([xf-h, yf-d/2], [xf, yf-d/2]),
                        "BottomCircle": new makerjs.paths.Circle([xf-h1, yf],r1),
                      }
                };
                var myLongClipGapWaterCut = {
                  paths: {
                    "EnLine": new makerjs.paths.Line([xf+cutLine, yf+d/2], [xf, yf+d/2]),
                    "LeftLine": new makerjs.paths.Line([xf, yf+d/2], [xf-h, yf+d/2]),
                    "BottomArcLf": new makerjs.paths.Arc([xf-h, yf+d/2], [xf-h-r, yf],r,false,false),
                    "slotLineLf": new makerjs.paths.Line([xf-h-r, yf], [xf-h1+r1, yf]),
                    "BottomCircleLf": new makerjs.paths.Arc([xf-h1+r1, yf],[xf-h1-r1, yf],r1,false,false),
                    "BottomCircleRt": new makerjs.paths.Arc([xf-h1-r1, yf],[xf-h1+r1, yf],r1,false,false),
                    "slotLineRt": new makerjs.paths.Line([xf-h1+r1, yf], [xf-h-r, yf]),
                    "BottomArcRt": new makerjs.paths.Arc([xf-h-r, yf], [xf-h, yf-d/2],r,false,false),
                    "RightLine": new makerjs.paths.Line([xf-h, yf-d/2], [xf, yf-d/2]),
                    "ExLine": new makerjs.paths.Line([xf, yf-d/2], [xf+cutLine, yf-d/2]),
                      }
                };
          } else if (area == "I") {
           var myLongClipGap = {
              paths: {
                  "LeftLine": new makerjs.paths.Line([xi, yi], [xi-h, yi]),
                  "BottomArc": new makerjs.paths.Arc([xi-h, yi], [xi-h, yi+d],r,false,true),
                  "RightLine": new makerjs.paths.Line([xi-h, yi+d], [xi, yi+d]),
                  "BottomCircle": new makerjs.paths.Circle([xi-h1, yi+d/2],r1),
              }
        };
        var myLongClipGapWaterCut = {
          paths: {
            "EnLine": new makerjs.paths.Line([xi+cutLine, yi], [xi, yi]),
            "LeftLine": new makerjs.paths.Line([xi, yi], [xi-h, yi]),
            "BottomArcLf": new makerjs.paths.Arc([xi-h, yi], [xi-h-r, yi+d/2],r,false,true),
            "slotLineLf": new makerjs.paths.Line([xi-h-r, yi+d/2], [xi-h1+r1, yi+d/2]),
            "BottomCircleLf": new makerjs.paths.Arc([xi-h1+r1, yi+d/2],[xi-h1-r1, yi+d/2],r1,false,true),
            "BottomCircleRt": new makerjs.paths.Arc([xi-h1-r1, yi+d/2],[xi-h1+r1, yi+d/2],r1,false,true),
            "slotLineRt": new makerjs.paths.Line([xi-h1+r1, yi+d/2], [xi-h-r, yi+d/2]),
            "BottomArcRt": new makerjs.paths.Arc([xi-h-r, yi+d/2], [xi-h, yi+d],r,false,true),
            "RightLine": new makerjs.paths.Line([xi-h, yi+d], [xi, yi+d]),
            "ExLine": new makerjs.paths.Line([xi, yi+d], [xi+cutLine, yi+d]),
              }
        };
          }
              
          var fillet1 = makerjs.path.fillet(myLongClipGapWaterCut.paths.BottomArcLf, myLongClipGapWaterCut.paths.slotLineLf, cutFilletRadius);
          var fillet2 = makerjs.path.fillet(myLongClipGapWaterCut.paths.slotLineLf, myLongClipGapWaterCut.paths.BottomCircleLf, cutFilletRadius);
          var fillet3 = makerjs.path.fillet(myLongClipGapWaterCut.paths.BottomCircleRt, myLongClipGapWaterCut.paths.slotLineRt, cutFilletRadius);
          var fillet4 = makerjs.path.fillet(myLongClipGapWaterCut.paths.slotLineRt, myLongClipGapWaterCut.paths.BottomArcRt, cutFilletRadius);
          myLongClipGapWaterCut.paths.fillet1 = fillet1;
          myLongClipGapWaterCut.paths.fillet2 = fillet2;
          myLongClipGapWaterCut.paths.fillet3 = fillet3;
          myLongClipGapWaterCut.paths.fillet4 = fillet4;
}
  
  return [myLongClipGap,myLongClipGapWaterCut];
};
// 矩形等去角标记 连线函数      
function creatmyLongClipGapMark(outParam, area, param, inputParam, fixedParam, OffsetParam, zoom) {
  console.log("是否调用此函数creatCornerMark()");
  console.log("是否调用此函数param", param);
  console.log("是否调用此函数outParam", outParam);
  console.log("是否调用此函数inputParam", inputParam);
  console.log("是否调用此函数OffsetParam", OffsetParam);
  var D=inputParam.D,H=inputParam.H,D1=inputParam.D1,H1=inputParam.H1,X=inputParam.X,Y=inputParam.Y, myZoom = zoom * 1,
  xa = param.xa, ya = param.ya, xb = param.xb, 
  xd = param.xd, yd = param.yd, xf = param.xf, yf = param.yf,
  yb = param.yb, xc = param.xc, 
  yc = param.yc, xg = param.xg, yg = param.yg, 
  xh = param.xh, yh = param.yh, xi = param.xi, yi = param.yi,
  x = param.x0, r = param.r, d = param.d,r1 = param.r1,d1 = param.d1, h = param.h,h1 = param.h1,
//   x0,rd,r,w,w1,h,d 
        glassW = outParam.glassW, glassH = outParam.glassH,
       markShift = fixedParam.markShift*1, markShiftTwo = fixedParam.markShiftTwo*1,
        markShiftThree = fixedParam.markShiftThree*1, markShiftFour = fixedParam.markShiftFour*1, markHolesOneD = fixedParam.markHolesOneD*1,
        d = D*1*myZoom,
        r = d/2,
           d1 = D1*1*myZoom,
           r1 = d1/2,
           h= H*1*myZoom,
           h1= H1*1*myZoom,
             x0 = X*1*myZoom,
             y0 = Y*1*myZoom;
             if(d!==0){
              var TxtD=D;
             }
             if(d1!==0){
              var TxtD1="∮"+D1;
             }
             if(h!==0){
              var TxtH=H;
             }
             if(h1!==0){
              var TxtH1=H1;
             }
             if(x0!==0){          
             var TxtX=X;
             }
             if(y0!==0){          
              var TxtY=Y;
             }

 if(glassW*1>glassH * 1){
 console.log("长边在X轴￥￥￥￥￥");
 console.log("x0,xh,yh,r,d===",x0,xh,yh,r,d);
 if (area == "A") {
      var myLcgGapAMakerD = {
            paths: {
                  "DALine0": new makerjs.paths.Line([xa+0,ya+0+markShift], [xa+d, ya+0+markShift]),
                  "DALine1": new makerjs.paths.Line([xa+d,ya+0], [xa+d, ya+markShiftFour]),
            }
      };
      var myLcgGapAMakerX = {
            paths: {
                  "XALine0": new makerjs.paths.Line([xa+0,ya+0], [xa+0, ya+markShiftFour]),
                  "XALine1": new makerjs.paths.Line([xa-x0,ya+0], [xa-x0, ya+markShiftFour]),
                  "XALine2": new makerjs.paths.Line([xa-x0,ya+0+markShiftTwo], [xa+0, ya+0+markShiftTwo]),
            }
      };
      var myLcgGapAMakerH = {
            paths: {
               "HALine0": new makerjs.paths.Line([xa+0,ya-h], [xa+0-markShiftFour, ya-h]),
               "HALine1": new makerjs.paths.Line([xa+0-markShift,ya-h], [xa+0-markShift, ya+0]),
              // "WALine2": new makerjs.paths.Line([xa, ya+ markShiftTwo], [xa+w, ya + markShiftTwo]),
            }
      };
      var myLcgGapAMakerH1 = {
            paths: {
               "H1ALine0": new makerjs.paths.Line([xa+d,ya-h1], [xa+d+markShiftFour+markShift, ya-h1]),
               "H1ALine1":new makerjs.paths.Line([xa+d+markShiftFour,ya-h1], [xa+d+markShiftFour, ya+0]),
              // "W1ALine2": new makerjs.paths.Line([xa, ya+ markShiftTwo], [xa+w, ya + markShiftTwo]),
            }
      };
      var myLcgGapAMakerD1 = {
            paths: {
               "D1ALine0": new makerjs.paths.Line([xa+d/2,ya-h1], [xa+d/2+0+d1, ya+0-h1-d1]),
              
            }
      };
        makerjs.model.addCaption(myLcgGapAMakerD, TxtD, [xa+0,ya+0+markShiftThree], [xa+d, ya+0+markShiftThree]);//W文字标注
        makerjs.model.addCaption(myLcgGapAMakerX, TxtX, [xa-x0,ya+0+markShiftFour], [xa+0, ya+0+markShiftFour]);//X文字标注
       makerjs.model.addCaption(myLcgGapAMakerH, TxtH, [xa+0-markShiftFour,ya-h], [xa+0-markShiftFour, ya+0]);//H文字标注    
        makerjs.model.addCaption(myLcgGapAMakerH1, TxtH1,[xa+d+markShiftFour+markShift,ya-h1], [xa+d+markShiftFour+markShift, ya+0]);//H1文字标注    
        makerjs.model.addCaption(myLcgGapAMakerD1, TxtD1, [xa+d/2,ya-h1],[xa+d/2+0+d1+markHolesOneD, ya-h1+0-d1-markHolesOneD]);//D文字标注  
        var markers = [myLcgGapAMakerH,myLcgGapAMakerX,myLcgGapAMakerD,myLcgGapAMakerH1,myLcgGapAMakerD1]
  } else if (area == "B") {
    var myLcgGapBMakerD = {
      paths: {
            "DALine0": new makerjs.paths.Line([xb+0-r,yb+0+markShift], [xb+d-r, yb+0+markShift]),
            "DALine1": new makerjs.paths.Line([xb+d-r,yb+0], [xb+d-r, yb+markShiftFour]),
      }
};
var myLcgGapBMakerX = {
      paths: {
            "XALine0": new makerjs.paths.Line([xb+0-r,yb+0], [xb+0-r, yb+markShiftFour]),
            "XALine1": new makerjs.paths.Line([xb-x0-r,yb+0], [xb-x0-r, yb+markShiftFour]),
            "XALine2": new makerjs.paths.Line([xb-x0-r,yb+0+markShiftTwo], [xb+0-r, yb+0+markShiftTwo]),
      }
};
var myLcgGapBMakerH = {
      paths: {
         "HALine0": new makerjs.paths.Line([xb+0-r,yb-h], [xb+0-r-markShiftFour, yb-h]),
         "HALine1": new makerjs.paths.Line([xb+0-r-markShift,yb-h], [xb+0-r-markShift, yb+0]),
        // "WALine2": new makerjs.paths.Line([xb, yb+ markShiftTwo], [xb+w, yb + markShiftTwo]),
      }
};
var myLcgGapBMakerH1 = {
      paths: {
         "H1ALine0": new makerjs.paths.Line([xb+d-r,yb-h1], [xb+d-r+markShiftFour+markShift, yb-h1]),
         "H1ALine1":new makerjs.paths.Line([xb+d-r+markShiftFour,yb-h1], [xb+d-r+markShiftFour, yb+0]),
        // "W1ALine2": new makerjs.paths.Line([xb, yb+ markShiftTwo], [xb+w, yb + markShiftTwo]),
      }
};
var myLcgGapBMakerD1 = {
      paths: {
         "D1ALine0": new makerjs.paths.Line([xb+d/2-r,yb-h1-r], [xb+d/2+0+d1-r, yb+0-h1-d1-r]),
        
      }
};
  makerjs.model.addCaption(myLcgGapBMakerD, TxtD, [xb+0-r,yb+0+markShiftThree], [xb+d-r, yb+0+markShiftThree]);//W文字标注
  makerjs.model.addCaption(myLcgGapBMakerX, TxtX, [xb-x0-r,yb+0+markShiftFour], [xb+0-r, yb+0+markShiftFour]);//X文字标注
 makerjs.model.addCaption(myLcgGapBMakerH, TxtH, [xb+0-r-markShiftFour,yb-h], [xb+0-r-markShiftFour, yb+0]);//H文字标注    
  makerjs.model.addCaption(myLcgGapBMakerH1, TxtH1,[xb+d-r+markShiftFour+markShift,yb-h1], [xb-r+d+markShiftFour+markShift, yb+0]);//H1文字标注    
  makerjs.model.addCaption(myLcgGapBMakerD1, TxtD1, [xb+d/2-r,yb-h1-r],[xb+d/2+0-r+d1+markHolesOneD, yb-h1+0-d1-markHolesOneD-r]);//D文字标注  
  var markers = [myLcgGapBMakerH,myLcgGapBMakerX,myLcgGapBMakerD,myLcgGapBMakerH1,myLcgGapBMakerD1]
  } else if (area == "C") {
    var myLcgGapCMakerD = {
      paths: {
            "DALine0": new makerjs.paths.Line([xc,yc+0+markShift], [xc-d, yc+0+markShift]),
            "DALine1": new makerjs.paths.Line([xc-d,yc+0], [xc-d, yc+markShiftFour]),
      }
};
var myLcgGapCMakerX = {
      paths: {
            "XALine0": new makerjs.paths.Line([xc+0,yc+0], [xc+0, yc+markShiftFour]),
            "XALine1": new makerjs.paths.Line([xc+x0,yc+0], [xc+x0, yc+markShiftFour]),
            "XALine2": new makerjs.paths.Line([xc+x0,yc+0+markShiftTwo], [xc+0, yc+0+markShiftTwo]),
      }
};
var myLcgGapCMakerH = {
      paths: {
         "HALine0": new makerjs.paths.Line([xc+0,yc-h], [xc+markShiftFour, yc-h]),
         "HALine1": new makerjs.paths.Line([xc+markShift,yc-h], [xc+markShift, yc+0]),
      }
};
var myLcgGapCMakerH1 = {
      paths: {
         "H1ALine0": new makerjs.paths.Line([xc-d,yc-h1], [xc-d-markShiftFour-markShift, yc-h1]),
         "H1ALine1":new makerjs.paths.Line([xc-d-markShiftFour,yc-h1], [xc-d-markShiftFour, yc+0]),
      }
};
var myLcgGapCMakerD1 = {
      paths: {
         "D1ALine0": new makerjs.paths.Line([xc-d/2,yc-h1], [xc-d/2-d1, yc+0-h1-d1]),
        
      }
};
  makerjs.model.addCaption(myLcgGapCMakerD, TxtD, [xc-d, yc+0+markShiftThree], [xc,yc+0+markShiftThree]);//W文字标注
  makerjs.model.addCaption(myLcgGapCMakerX, TxtX, [xc, yc+0+markShiftFour], [xc+x0,yc+0+markShiftFour]);//X文字标注
 makerjs.model.addCaption(myLcgGapCMakerH, TxtH, [xc+markShiftFour,yc-h], [xc+markShiftFour, yc+0]);//H文字标注    
  makerjs.model.addCaption(myLcgGapCMakerH1, TxtH1,[xc-d-markShiftFour-markShift,yc-h1], [xc-d-markShiftFour-markShift, yc+0]);//H1文字标注    
  makerjs.model.addCaption(myLcgGapCMakerD1, TxtD1, [xc-d/2,yc-h1],[xc-d/2-d1-markHolesOneD, yc-h1+0-d1-markHolesOneD]);//D文字标注  
  var markers = [myLcgGapCMakerH,myLcgGapCMakerX,myLcgGapCMakerD,myLcgGapCMakerH1,myLcgGapCMakerD1]
  } else if (area == "G") {
    var myLcgGapGMakerD = {
      paths: {
            "DALine0": new makerjs.paths.Line([xg,yg-markShiftTwo], [xg+d, yg-markShiftTwo]),
            "DALine1": new makerjs.paths.Line([xg+d,yg], [xg+d, yg-markShiftFour]),
      }
};
var myLcgGapGMakerX = {
      paths: {
            "XALine0": new makerjs.paths.Line([xg,yg], [xg, yg-markShiftFour]),
            "XALine1": new makerjs.paths.Line([xg-x0,yg], [xg-x0, yg-markShiftFour]),
            "XALine2": new makerjs.paths.Line([xg-x0,yg-markShiftTwo], [xg, yg-markShiftTwo]),
      }
};
var myLcgGapGMakerH = {
      paths: {
         "HALine0": new makerjs.paths.Line([xg+0,yg+h], [xg+0-markShiftFour, yg+h]),
         "HALine1": new makerjs.paths.Line([xg+0-markShift,yg+h], [xg+0-markShift, yg+0]),
      }
};
var myLcgGapGMakerH1 = {
      paths: {
         "H1ALine0": new makerjs.paths.Line([xg+d,yg+h1], [xg+d+markShiftFour+markShift, yg+h1]),
         "H1ALine1":new makerjs.paths.Line([xg+d+markShiftFour,yg+h1], [xg+d+markShiftFour, yg+0]),
      }
};
var myLcgGapGMakerD1 = {
      paths: {
         "D1ALine0": new makerjs.paths.Line([xg+d/2,yg+h1], [xg+d/2+0+d1, yg+h1+d1]),
        
      }
};
  makerjs.model.addCaption(myLcgGapGMakerD, TxtD, [xg+0,yg-markShiftFour], [xg+d, yg-markShiftFour]);//W文字标注
  makerjs.model.addCaption(myLcgGapGMakerX, TxtX, [xg-x0,yg-markShiftFour], [xg+0, yg-markShiftFour]);//X文字标注
 makerjs.model.addCaption(myLcgGapGMakerH, TxtH, [xg+0-markShiftFour, yg+0], [xg+0-markShiftFour,yg+h]);//H文字标注    
  makerjs.model.addCaption(myLcgGapGMakerH1, TxtH1, [xg+d+markShiftFour+markShift, yg+0],[xg+d+markShiftFour+markShift,yg+h1]);//H1文字标注    
  makerjs.model.addCaption(myLcgGapGMakerD1, TxtD1, [xg+d/2,yg+h1],[xg+d/2+0+d1+markHolesOneD, yg+h1+d1+markHolesOneD]);//D文字标注  
  var markers = [myLcgGapGMakerH,myLcgGapGMakerX,myLcgGapGMakerD,myLcgGapGMakerH1,myLcgGapGMakerD1]
  } else if (area == "H") {
    var myLcgGapHMakerD = {
      paths: {
            "DALine0": new makerjs.paths.Line([xh-d/2,yh+markShift], [xh+d/2, yh+markShift]),
            // "DALine1": new makerjs.paths.Line([xh+d,yh], [xh+d, yh-markShiftFour]),
      }
};
var myLcgGapHMakerX = {
      paths: {
            // "XALine0": new makerjs.paths.Line([xh,yh], [xh, yh-markShiftFour]),
            // "XALine1": new makerjs.paths.Line([xh-x0,yh], [xh-x0, yh-markShiftFour]),
            // "XALine2": new makerjs.paths.Line([xh-x0,yh-markShiftTwo], [xh, yh-markShiftTwo]),
      }
};
var myLcgGapHMakerH = {
      paths: {
         "HALine0": new makerjs.paths.Line([xh-d/2,yh+h], [xh-d/2-markShiftFour, yh+h]),
         "HALine1": new makerjs.paths.Line([xh-d/2-markShift,yh+h], [xh-d/2-markShift, yh+0]),
      }
};
var myLcgGapHMakerH1 = {
      paths: {
         "H1ALine0": new makerjs.paths.Line([xh+d/2,yh+h1], [xh+d/2+markShiftFour+markShift, yh+h1]),
         "H1ALine1":new makerjs.paths.Line([xh+d/2+markShiftFour,yh+h1], [xh+d/2+markShiftFour, yh+0]),
      }
};
var myLcgGapHMakerD1 = {
      paths: {
         "D1ALine0": new makerjs.paths.Line([xh,yh+h1], [xh+d1, yh+h1+d1]),
        
      }
};
  makerjs.model.addCaption(myLcgGapHMakerD, TxtD, [xh-d/2,yh+markShiftThree], [xh+d/2, yh+markShiftThree]);//W文字标注
  makerjs.model.addCaption(myLcgGapHMakerX, TxtX, [xh-d/2,yh-markShiftFour], [xh-d/2, yh-markShiftFour]);//X文字标注
 makerjs.model.addCaption(myLcgGapHMakerH, TxtH, [xh-d/2-markShiftFour, yh+0], [xh-d/2-markShiftFour,yh+h]);//H文字标注    
  makerjs.model.addCaption(myLcgGapHMakerH1, TxtH1, [xh+d/2+markShiftFour+markShift, yh+0],[xh+d/2+markShiftFour+markShift,yh+h1]);//H1文字标注    
  makerjs.model.addCaption(myLcgGapHMakerD1, TxtD1, [xh,yh+h1],[xh+d1+markHolesOneD, yh+h1+d1+markHolesOneD]);//D文字标注  
  var markers = [myLcgGapHMakerH,myLcgGapHMakerX,myLcgGapHMakerD,myLcgGapHMakerH1,myLcgGapHMakerD1]
  } else if (area == "I") {
    var myLcgGapIMakerD = {
      paths: {
            "DALine0": new makerjs.paths.Line([xi,yi-markShiftTwo], [xi-d, yi-markShiftTwo]),
            "DALine1": new makerjs.paths.Line([xi-d,yi+0], [xi-d, yi-markShiftFour]),
      }
};
var myLcgGapIMakerX = {
      paths: {
            "XALine0": new makerjs.paths.Line([xi+0,yi+0], [xi+0, yi-markShiftFour]),
            "XALine1": new makerjs.paths.Line([xi+x0,yi+0], [xi+x0, yi-markShiftFour]),
            "XALine2": new makerjs.paths.Line([xi+x0,yi-markShiftTwo], [xi+0, yi-markShiftTwo]),
      }
};
var myLcgGapIMakerH = {
      paths: {
         "HALine0": new makerjs.paths.Line([xi+0,yi+h], [xi+markShiftFour, yi+h]),
         "HALine1": new makerjs.paths.Line([xi+markShift,yi+h], [xi+markShift, yi+0]),
      }
};
var myLcgGapIMakerH1 = {
      paths: {
         "H1ALine0": new makerjs.paths.Line([xi-d,yi+h1], [xi-d-markShiftFour-markShift, yi+h1]),
         "H1ALine1":new makerjs.paths.Line([xi-d-markShiftFour,yi+h1], [xi-d-markShiftFour, yi+0]),
      }
};
var myLcgGapIMakerD1 = {
      paths: {
         "D1ALine0": new makerjs.paths.Line([xi-d/2,yi+h1], [xi-d/2-d1, yi+h1+d1]),
        
      }
};
  makerjs.model.addCaption(myLcgGapIMakerD, TxtD, [xi-d, yi-markShiftFour], [xi,yi-markShiftFour]);//W文字标注
  makerjs.model.addCaption(myLcgGapIMakerX, TxtX, [xi, yi-markShiftFour], [xi+x0,yi-markShiftFour]);//X文字标注
 makerjs.model.addCaption(myLcgGapIMakerH, TxtH, [xi+markShiftFour, yi+0], [xi+markShiftFour,yi+h]);//H文字标注    
  makerjs.model.addCaption(myLcgGapIMakerH1, TxtH1, [xi-d-markShiftFour-markShift, yi+0],[xi-d-markShiftFour-markShift,yi+h1]);//H1文字标注    
  makerjs.model.addCaption(myLcgGapIMakerD1, TxtD1, [xi-d/2,yi+h1],[xi-d/2-d1-markHolesOneD, yi+h1+d1+markHolesOneD]);//D文字标注  
  var markers = [myLcgGapIMakerH,myLcgGapIMakerX,myLcgGapIMakerD,myLcgGapIMakerH1,myLcgGapIMakerD1]
  }            
}else{
console.log("短边在X轴￥￥￥￥￥");
if (area == "A") {
      var myLcgGapAMakerD = {
            paths: {
                  "DALine0": new makerjs.paths.Line([xa+markShift,ya], [xa+markShift, ya-d]),
                  // "DALine1": new makerjs.paths.Line([xa+d,ya+0], [xa+d, ya+markShiftFour]),
            }
      };
      var myLcgGapAMakerY = {
            paths: {
                  "YALine0": new makerjs.paths.Line([xa-markShiftFour,ya+y0], [xa, ya+y0]),
                  "YALine1": new makerjs.paths.Line([xa-markShiftFour,ya], [xa, ya]),
                  "YALine2": new makerjs.paths.Line([xa-markShiftTwo,ya], [xa-markShiftTwo, ya+y0]),
            }
      };
      var myLcgGapAMakerH = {
            paths: {
               "HALine0": new makerjs.paths.Line([xa,ya+markShift], [xa+h,ya+markShift]),
               "HALine1": new makerjs.paths.Line([xa+h,ya], [xa+h, ya+markShiftFour]),
              // "WALine2": new makerjs.paths.Line([xa, ya+ markShiftTwo], [xa+w, ya + markShiftTwo]),
            }
      };
      var myLcgGapAMakerH1 = {
            paths: {
               "H1ALine0": new makerjs.paths.Line([xa,ya-d-markShift], [xa+h1,ya-d-markShift]),
               "H1ALine1":new makerjs.paths.Line([xa+h1,ya-d/2], [xa+h1,ya-d-markShiftFour]),
              // "W1ALine2": new makerjs.paths.Line([xa, ya+ markShiftTwo], [xa+w, ya + markShiftTwo]),
            }
      };
      var myLcgGapAMakerD1 = {
            paths: {
               "D1ALine0": new makerjs.paths.Line([xa+h1,ya-d/2], [xa+h1+d1+markShift,ya-d/2+d1+markShift]),
              
            }
      };
        makerjs.model.addCaption(myLcgGapAMakerD, TxtD, [xa+markShiftThree,ya-d], [xa+markShiftThree, ya]);//W文字标注
        makerjs.model.addCaption(myLcgGapAMakerY, TxtY, [xa-markShiftFour,ya], [xa-markShiftFour, ya+y0]);//X文字标注
       makerjs.model.addCaption(myLcgGapAMakerH, TxtH, [xa,ya+markShiftThree], [xa+h,ya+markShiftThree]);//H文字标注    
        makerjs.model.addCaption(myLcgGapAMakerH1, TxtH1,[xa,ya-d-markShiftThree], [xa+h1,ya-d-markShiftThree]);//H1文字标注    
        makerjs.model.addCaption(myLcgGapAMakerD1, TxtD1, [xa+h1+d1+markShift,ya-d/2+d1+markShift],[xa+h1+d1+markShiftFour,ya-d/2+d1+markShift]);//D文字标注  
        var markers = [myLcgGapAMakerH,myLcgGapAMakerY,myLcgGapAMakerD,myLcgGapAMakerH1,myLcgGapAMakerD1]
  } else if (area == "D") {
      var myLcgGapDMakerD = {
            paths: {
                  "DDLine0": new makerjs.paths.Line([xd+markShift,yd-d/2], [xd+markShift, yd+d/2]),
                  // "DDLine1": new makerjs.paths.Line([xd+d,yd+0], [xd+d, yd+markShiftFour]),
            }
      };
      var myLcgGapDMakerY = {
            paths: {
                  // "YDLine0": new makerjs.paths.Line([xd-markShiftFour,yd+y0+d/2], [xd, yd+y0+d/2]),
                  // "YDLine1": new makerjs.paths.Line([xd-markShiftFour,yd+d/2], [xd, yd+d/2]),
                  // "YDLine2": new makerjs.paths.Line([xd-markShiftTwo,yd+d/2], [xd-markShiftTwo, yd+y0+d/2]),
            }
      };
      var myLcgGapDMakerH = {
            paths: {
               "HDLine0": new makerjs.paths.Line([xd,yd+markShift+d/2], [xd+h,yd+markShift+d/2]),
               "HDLine1": new makerjs.paths.Line([xd+h,yd+d/2], [xd+h, yd+markShiftFour+d/2]),
              // "WDLine2": new makerjs.paths.Line([xd, yd+ markShiftTwo], [xd+w, yd + markShiftTwo]),
            }
      };
      var myLcgGapDMakerH1 = {
            paths: {
               "H1DLine0": new makerjs.paths.Line([xd,yd-d/2-markShift], [xd+h1,yd-d/2-markShift]),
               "H1DLine1":new makerjs.paths.Line([xd+h1,yd], [xd+h1,yd-d/2-markShiftFour]),
              // "W1DLine2": new makerjs.paths.Line([xd, yd+ markShiftTwo], [xd+w, yd + markShiftTwo]),
            }
      };
      var myLcgGapDMakerD1 = {
            paths: {
               "D1DLine0": new makerjs.paths.Line([xd+h1,yd], [xd+h1+d1+markShift,yd+d1+markShift]),
              
            }
      };
        makerjs.model.addCaption(myLcgGapDMakerD, TxtD, [xd+markShiftThree,yd-d/2], [xd+markShiftThree, yd+d/2]);//W文字标注
        makerjs.model.addCaption(myLcgGapDMakerY, TxtY, [xd-markShiftFour,yd+d/2], [xd-markShiftFour, yd+y0+d/2]);//X文字标注
       makerjs.model.addCaption(myLcgGapDMakerH, TxtH, [xd,yd+markShiftThree+d/2], [xd+h,yd+markShiftThree+d/2]);//H文字标注    
        makerjs.model.addCaption(myLcgGapDMakerH1, TxtH1,[xd,yd-d/2-markShiftThree], [xd+h1,yd-d/2-markShiftThree]);//H1文字标注    
        makerjs.model.addCaption(myLcgGapDMakerD1, TxtD1, [xd+h1+d1+markShift,yd+d1+markShift],[xd+h1+d1+markShiftFour,yd+d1+markShift]);//D文字标注  
        var markers = [myLcgGapDMakerH,myLcgGapDMakerY,myLcgGapDMakerD,myLcgGapDMakerH1,myLcgGapDMakerD1]
  } else if (area == "C") {
      var myLcgGapCMakerD = {
            paths: {
                  "DCLine0": new makerjs.paths.Line([xc-markShift,yc], [xc-markShift, yc-d]),
                  // "DCLine1": new makerjs.paths.Line([xc+d,yc+0], [xc+d, yc+markShiftFour]),
            }
      };
      var myLcgGapCMakerY = {
            paths: {
                  "YCLine0": new makerjs.paths.Line([xc+markShiftFour,yc+y0], [xc, yc+y0]),
                  "YCLine1": new makerjs.paths.Line([xc+markShiftFour,yc], [xc, yc]),
                  "YCLine2": new makerjs.paths.Line([xc+markShiftTwo,yc], [xc+markShiftTwo, yc+y0]),
            }
      };
      var myLcgGapCMakerH = {
            paths: {
               "HCLine0": new makerjs.paths.Line([xc,yc+markShift], [xc-h,yc+markShift]),
               "HCLine1": new makerjs.paths.Line([xc-h,yc], [xc-h, yc+markShiftFour]),
              // "WCLine2": new makerjs.paths.Line([xc, yc+ markShiftTwo], [xc+w, yc + markShiftTwo]),
            }
      };
      var myLcgGapCMakerH1 = {
            paths: {
               "H1CLine0": new makerjs.paths.Line([xc,yc-d-markShift], [xc-h1,yc-d-markShift]),
               "H1CLine1":new makerjs.paths.Line([xc-h1,yc-d/2], [xc-h1,yc-d-markShiftFour]),
              // "W1CLine2": new makerjs.paths.Line([xc, yc+ markShiftTwo], [xc+w, yc + markShiftTwo]),
            }
      };
      var myLcgGapCMakerD1 = {
            paths: {
               "D1CLine0": new makerjs.paths.Line([xc-h1,yc-d/2], [xc-h1-d1-markShift,yc-d/2+d1+markShift]),
              
            }
      };
        makerjs.model.addCaption(myLcgGapCMakerD, TxtD, [xc-markShiftThree,yc-d], [xc-markShiftThree, yc]);//W文字标注
        makerjs.model.addCaption(myLcgGapCMakerY, TxtY, [xc+markShiftFour,yc], [xc+markShiftFour, yc+y0]);//X文字标注
       makerjs.model.addCaption(myLcgGapCMakerH, TxtH, [xc-h,yc+markShiftThree], [xc,yc+markShiftThree]);//H文字标注    
        makerjs.model.addCaption(myLcgGapCMakerH1, TxtH1,[xc-h1,yc-d-markShiftThree], [xc,yc-d-markShiftThree]);//H1文字标注    
        makerjs.model.addCaption(myLcgGapCMakerD1, TxtD1,[xc-h1-d1-markShiftFour,yc-d/2+d1+markShift], [xc-h1-d1-markShift,yc-d/2+d1+markShift]);//D文字标注  
        var markers = [myLcgGapCMakerH,myLcgGapCMakerY,myLcgGapCMakerD,myLcgGapCMakerH1,myLcgGapCMakerD1]
  } else if (area == "G") {
      var myLcgGapGMakerD = {
            paths: {
                  "DGLine0": new makerjs.paths.Line([xg+markShift,yg], [xg+markShift, yg+d]),
                  // "DGLine1": new makerjs.paths.Line([xg+d,yg+0], [xg+d, yg+markShiftFour]),
            }
      };
      var myLcgGapGMakerY = {
            paths: {
                  "YGLine0": new makerjs.paths.Line([xg-markShiftFour,yg-y0], [xg, yg-y0]),
                  "YGLine1": new makerjs.paths.Line([xg-markShiftFour,yg], [xg, yg]),
                  "YGLine2": new makerjs.paths.Line([xg-markShiftTwo,yg], [xg-markShiftTwo, yg-y0]),
            }
      };
      var myLcgGapGMakerH = {
            paths: {
               "HGLine0": new makerjs.paths.Line([xg,yg-markShift], [xg+h,yg-markShift]),
               "HGLine1": new makerjs.paths.Line([xg+h,yg], [xg+h, yg-markShiftFour]),
              // "WGLine2": new makerjs.paths.Line([xg, yg+ markShiftTwo], [xg+w, yg + markShiftTwo]),
            }
      };
      var myLcgGapGMakerH1 = {
            paths: {
               "H1GLine0": new makerjs.paths.Line([xg,yg+d+markShift], [xg+h1,yg+d+markShift]),
               "H1GLine1":new makerjs.paths.Line([xg+h1,yg+d/2], [xg+h1,yg+d+markShiftFour]),
              // "W1GLine2": new makerjs.paths.Line([xg, yg+ markShiftTwo], [xg+w, yg + markShiftTwo]),
            }
      };
      var myLcgGapGMakerD1 = {
            paths: {
               "D1GLine0": new makerjs.paths.Line([xg+h1,yg+d/2], [xg+h1+d1+markShift,yg+d/2-d1-markShift]),
              
            }
      };
        makerjs.model.addCaption(myLcgGapGMakerD, TxtD, [xg+markShiftThree,yg], [xg+markShiftThree, yg+d]);//W文字标注
        makerjs.model.addCaption(myLcgGapGMakerY, TxtY, [xg-markShiftFour,yg-y0], [xg-markShiftFour, yg]);//X文字标注
       makerjs.model.addCaption(myLcgGapGMakerH, TxtH, [xg,yg-markShiftThree], [xg+h,yg-markShiftThree]);//H文字标注    
        makerjs.model.addCaption(myLcgGapGMakerH1, TxtH1,[xg,yg+d+markShiftThree], [xg+h1,yg+d+markShiftThree]);//H1文字标注    
        makerjs.model.addCaption(myLcgGapGMakerD1, TxtD1, [xg+h1+d1+markShift,yg+d/2-d1-markShift],[xg+h1+d1+markShiftFour,yg+d/2-d1-markShift]);//D文字标注  
        var markers = [myLcgGapGMakerH,myLcgGapGMakerY,myLcgGapGMakerD,myLcgGapGMakerH1,myLcgGapGMakerD1]
  } else if (area == "F") {
      var myLcgGapFMakerD = {
            paths: {
                  "DFLine0": new makerjs.paths.Line([xf-markShift,yf+d/2], [xf-markShift, yf-d/2]),
                  // "DFLine1": new makerjs.paths.Line([xf+d,yf+0], [xf+d, yf+markShiftFour]),
            }
      };
      var myLcgGapFMakerY = {
            paths: {
                  // "YFLine0": new makerjs.paths.Line([xf+markShiftFour,yf+y0+d/2], [xf, yf+y0+d/2]),
                  // "YFLine1": new makerjs.paths.Line([xf+markShiftFour,yf+d/2], [xf, yf+d/2]),
                  // "YFLine2": new makerjs.paths.Line([xf+markShiftTwo,yf+d/2], [xf+markShiftTwo, yf+y0+d/2]),
            }
      };
      var myLcgGapFMakerH = {
            paths: {
               "HFLine0": new makerjs.paths.Line([xf,yf+markShift+d/2], [xf-h,yf+markShift+d/2]),
               "HFLine1": new makerjs.paths.Line([xf-h,yf+d/2], [xf-h, yf+markShiftFour+d/2]),
              // "WFLine2": new makerjs.paths.Line([xf, yf+ markShiftTwo], [xf+w, yf + markShiftTwo]),
            }
      };
      var myLcgGapFMakerH1 = {
            paths: {
               "H1FLine0": new makerjs.paths.Line([xf,yf-d/2-markShift], [xf-h1,yf-d/2-markShift]),
               "H1FLine1":new makerjs.paths.Line([xf-h1,yf], [xf-h1,yf-d/2-markShiftFour]),
              // "W1FLine2": new makerjs.paths.Line([xf, yf+ markShiftTwo], [xf+w, yf + markShiftTwo]),
            }
      };
      var myLcgGapFMakerD1 = {
            paths: {
               "D1FLine0": new makerjs.paths.Line([xf-h1,yf], [xf-h1-d1-markShift,yf+d1+markShift]),
              
            }
      };
        makerjs.model.addCaption(myLcgGapFMakerD, TxtD, [xf-markShiftThree,yf-d/2], [xf-markShiftThree, yf+d/2]);//W文字标注
        makerjs.model.addCaption(myLcgGapFMakerY, TxtY, [xf+markShiftFour,yf+d/2], [xf+markShiftFour, yf+y0+d/2]);//X文字标注
       makerjs.model.addCaption(myLcgGapFMakerH, TxtH, [xf-h,yf+markShiftThree+d/2], [xf,yf+markShiftThree+d/2]);//H文字标注    
        makerjs.model.addCaption(myLcgGapFMakerH1, TxtH1,[xf-h1,yf-d/2-markShiftThree], [xf,yf-d/2-markShiftThree]);//H1文字标注    
        makerjs.model.addCaption(myLcgGapFMakerD1, TxtD1,[xf-h1-d1-markShiftFour,yf+d1+markShift], [xf-h1-d1-markShift,yf+d1+markShift]);//F文字标注  
        var markers = [myLcgGapFMakerH,myLcgGapFMakerY,myLcgGapFMakerD,myLcgGapFMakerH1,myLcgGapFMakerD1]
  } else if (area == "I") {
      var myLcgGapDMakerD = {
            paths: {
                  "DDLine0": new makerjs.paths.Line([xi-markShift,yi], [xi-markShift, yi+d]),
                  // "DDLine1": new makerjs.paths.Line([xi+d,yi+0], [xi+d, yi+markShiftFour]),
            }
      };
      var myLcgGapDMakerY = {
            paths: {
                  "YDLine0": new makerjs.paths.Line([xi+markShiftFour,yi-y0], [xi, yi-y0]),
                  "YDLine1": new makerjs.paths.Line([xi+markShiftFour,yi], [xi, yi]),
                  "YDLine2": new makerjs.paths.Line([xi+markShiftTwo,yi], [xi+markShiftTwo, yi-y0]),
            }
      };
      var myLcgGapDMakerH = {
            paths: {
               "HDLine0": new makerjs.paths.Line([xi,yi-markShift], [xi-h,yi-markShift]),
               "HDLine1": new makerjs.paths.Line([xi-h,yi], [xi-h, yi-markShiftFour]),
              // "WDLine2": new makerjs.paths.Line([xi, yi+ markShiftTwo], [xi+w, yi + markShiftTwo]),
            }
      };
      var myLcgGapDMakerH1 = {
            paths: {
               "H1DLine0": new makerjs.paths.Line([xi,yi+d+markShift], [xi-h1,yi+d+markShift]),
               "H1DLine1":new makerjs.paths.Line([xi-h1,yi+d/2], [xi-h1,yi+d+markShiftFour]),
              // "W1DLine2": new makerjs.paths.Line([xi, yi+ markShiftTwo], [xi+w, yi + markShiftTwo]),
            }
      };
      var myLcgGapDMakerD1 = {
            paths: {
               "D1DLine0": new makerjs.paths.Line([xi-h1,yi+d/2], [xi-h1-d1-markShift,yi+d/2-d1-markShift]),
              
            }
      };
        makerjs.model.addCaption(myLcgGapDMakerD, TxtD, [xi-markShiftThree,yi], [xi-markShiftThree, yi+d]);//W文字标注
        makerjs.model.addCaption(myLcgGapDMakerY, TxtY, [xi+markShiftFour,yi-y0], [xi+markShiftFour, yi]);//X文字标注
       makerjs.model.addCaption(myLcgGapDMakerH, TxtH, [xi-h,yi-markShiftThree], [xi,yi-markShiftThree]);//H文字标注    
        makerjs.model.addCaption(myLcgGapDMakerH1, TxtH1,[xi-h1,yi+d+markShiftThree], [xi,yi+d+markShiftThree]);//H1文字标注    
        makerjs.model.addCaption(myLcgGapDMakerD1, TxtD1,[xi-h1-d1-markShiftFour,yi+d/2-d1-markShift], [xi-h1-d1-markShift,yi+d/2-d1-markShift]);//D文字标注  
        var markers = [myLcgGapDMakerH,myLcgGapDMakerY,myLcgGapDMakerD,myLcgGapDMakerH1,myLcgGapDMakerD1]
  }            
}
  
  console.log("markers||||||||||||||||||=", markers)
  return markers;
};
// inputParam,model,myHolesNum,outParam,fixedParam
// (D,X,Y,area,plate,markers,myHolesNum,glassW,glassH,markShift,markShiftTwo,markShiftThree,markShiftFour,markHolesOneD)
function LongClipGap(inputParam, model, myHolesNum, outParam, fixedParam, zoom, θCut, rCut,cutLine,cutFilletRadius){

  var frame = outParam.shapeName;
  console.log("outParam==", outParam)
  console.log("model==", model)
  console.log("inputParam==", inputParam)
  console.log("outParam.shapeName==////////", outParam.shapeName)
  if (typeof (frame) == "undefined") {
        var D=inputParam.D,H=inputParam.H,D1=inputParam.D1,H1=inputParam.H1,X=inputParam.X,Y=inputParam.Y,area=inputParam.area,myZoom=zoom*1, myθCut = θCut, myrCut = rCut,
        plate = model.plate, cutPlate = model.cutPlate, markers = model.markers, frame = "Rectangle",
              glassW = outParam.glassW, glassH = outParam.glassH,cutLine=cutLine*1,cutFilletRadius=cutFilletRadius*1,
              markShift = fixedParam.markShift, markShiftTwo = fixedParam.markShiftTwo,
              markShiftThree = fixedParam.markShiftThree, markShiftFour = fixedParam.markShiftFour, markHolesOneD = fixedParam.markHolesOneD,
              d = D*1*myZoom,
              r = d/2,
                 d1 = D1*1*myZoom,
                 r1 = d1/2,
                 h= H*1*myZoom,
                 h1= H1*1*myZoom,
                   x0 = X*1*myZoom,
                   y0 = Y*1*myZoom;
                   if(plate.models===undefined||plate.models===""){
                        console.log("1111111111111111");
                        plate.models={};
                                }        
                                if(cutPlate.models===undefined||cutPlate.models===""){
                                    console.log("22222222222");
                                    //cutPlate.models={};
                                    cutPlate.models={};
                                }
                                if(markers.models===undefined||markers.models===""){            
                                    console.log("333333333333");
                                    markers.models={};
                                }
                   if(d!==0){
                    var TxtD="∮"+D;
                   }
                   if(d1!==0){
                    var TxtD1="∮"+D1;
                   }
                   if(h!==0){
                    var TxtH=H;
                   }
                   if(h1!==0){
                    var TxtH1=H1;
                   }
                   if(x0!==0){          
                   var TxtX=X;
                   }
                   if(y0!==0){          
                    var TxtY=Y;
                   }
  } else {
        var D=inputParam.D,H=inputParam.H,D1=inputParam.D1,H1=inputParam.H1,X=inputParam.X,Y=inputParam.Y,area=inputParam.area,myZoom=zoom*1, myθCut = θCut, myrCut = rCut,
        plate = model.plate, cutPlate = model.cutPlate, markers = model.markers, frame = outParam.shapeName,
              glassW = outParam.glassW, glassH = outParam.glassH,cutLine=cutLine*1,cutFilletRadius=cutFilletRadius*1,
              markShift = fixedParam.markShift, markShiftTwo = fixedParam.markShiftTwo,
              markShiftThree = fixedParam.markShiftThree, markShiftFour = fixedParam.markShiftFour, markHolesOneD = fixedParam.markHolesOneD,
              d = D*1*myZoom,
              r = d/2,
                 d1 = D1*1*myZoom,
                 r1 = d1/2,
                 h= H*1*myZoom,
                 h1= H1*1*myZoom,
                   x0 = X*1*myZoom,
                   y0 = Y*1*myZoom;
                   if(plate.models===undefined||plate.models===""){
                        console.log("1111111111111111");
                        plate.models={};
                                }        
                                if(cutPlate.models===undefined||cutPlate.models===""){
                                    console.log("22222222222");
                                    //cutPlate.models={};
                                    cutPlate.models={};
                                }
                                if(markers.models===undefined||markers.models===""){            
                                    console.log("333333333333");
                                    markers.models={};
                                }
                   if(d!==0){
                    var TxtD="∮"+D;
                   }
                   if(d1!==0){
                    var TxtD1="∮"+D1;
                   }
                   if(h!==0){
                    var TxtH=H;
                   }
                   if(h1!==0){
                    var TxtH1=H1;
                   }
                   if(x0!==0){          
                   var TxtX=X;
                   }
                   if(y0!==0){          
                    var TxtY=Y;
                   }
  }
  if (frame == "Rectangle") {
        console.log("frame==undefined||||*****")
        //在A区域 计算孔的位置       
        var xa = x0, ya = glassH * 1 - y0,
              //B区域//只有Y标注没有X标注 
              xb = glassW * 1 / 2, yb = glassH * 1 - y0,
              //C区域
              xc = glassW * 1 - x0, yc = glassH * 1 - y0,
              //在G区域 计算孔的位置
                  //D区域
  //只有X标注没有Y标注 
  xd=x0,yd=glassH * 1/2,
  //E区域
  //只有X标注没有Y标注 
  xe=glassW * 1/2,ye=glassH * 1/2,
  //F区域
  //只有X标注没有Y标注 
  xf=glassW * 1-x0,yf=glassH * 1/2,
              xg = x0, yg = y0,
              //在H区域 计算孔的位置
              //只标注Y
              xh = glassW * 1 / 2, yh = y0,
              //在I区域 计算孔的位置
              xi = glassW * 1 - x0, yi = y0;
        var OffsetParam = {};
  } else if (frame == "IsoscelesTrapezoid") {

  } else if (frame == "RightAngledTrapezoid") {d

  } else if (frame == "OtherTrapezoidsA") {

  } else if (frame == "OtherTrapezoidsB") {

  } else if (frame == "ParallelogramA") {


  } else if (frame == "ParallelogramB") {

  }
  // 坐标参数
  var paramCoordinate = { x0,d,r,cutLine,cutFilletRadius,d1,r1,h,h1,xa, ya, xb, yb, xc, yc, xd, yd, xf, yf, xg, yg, xh, yh, xi, yi,glassW,glassH};
  const allKeys = Object.getOwnPropertyNames(JSON.parse(JSON.stringify(model.plate.models)));
  var areaPoint = "";
  console.log("//角7、地弹簧3 ------", allKeys)
  if (allKeys[0] == frame) {
        allKeys.shift();//去掉数组第一个元素
  }
  console.log("//角7、地弹簧3 位置去掉数组第一个元素------", allKeys)
  switch (area) {
        case "1": areaPoint = "A"; break;
        case "2": areaPoint = "B"; break;
        case "3": areaPoint = "C"; break;
        case "4": areaPoint = "D"; break;
        case "6": areaPoint = "F"; break;
        case "7": areaPoint = "G"; break;
        case "8": areaPoint = "H"; break;
        case "9": areaPoint = "I"; break;
  }
  /**
  * 画图
  * 
  */
  var ObjName = "myLongClipGap" + areaPoint;
  var ObjNameMmyLongClipGap = "myLongClipGap" + areaPoint + "Mark";//角标记
  ObjName = creatmyLongClipGap(areaPoint, paramCoordinate);//图形
  console.log("ObjName===|||||||||", ObjName);
  ObjNameMmyLongClipGap = creatmyLongClipGapMark(outParam, areaPoint, paramCoordinate, inputParam, fixedParam, OffsetParam, zoom);//图形
  console.log("ObjNameMmyLongClipGap===|||||||||角标注", ObjNameMmyLongClipGap);
  console.log("cutPlate.models====************", cutPlate.models),
        console.log("plate.models====**************", plate.models),
        console.log("markers.models====*************", markers.models),
     // myLcgGapAMakerH,myLcgGapAMakerX,myLcgGapAMakerD,myLcgGapAMakerH1,myLcgGapAMakerD1
        cutPlate.models["TypeGapes_myLongClipGap" + areaPoint + myHolesNum] = ObjName[1];
  plate.models["TypeGapes_myLongClipGap" + areaPoint + myHolesNum] = ObjName[1];
  markers.models["TypeGapes_myLongClipGap" + areaPoint + myHolesNum] = ObjName[1];
  markers.models["TypeGapes_myLongClipGapH" + areaPoint + myHolesNum + "Mark"] = ObjNameMmyLongClipGap[0];
  markers.models["TypeGapes_myLongClipGapX" + areaPoint + myHolesNum + "Mark"] = ObjNameMmyLongClipGap[1];
  markers.models["TypeGapes_myLongClipGapD" + areaPoint + myHolesNum + "Mark"] = ObjNameMmyLongClipGap[2];
  markers.models["TypeGapes_myLongClipGapH1" + areaPoint + myHolesNum + "Mark"] = ObjNameMmyLongClipGap[3];
  markers.models["TypeGapes_myLongClipGapD1" + areaPoint + myHolesNum + "Mark"] = ObjNameMmyLongClipGap[4];

myHolesNum++;
return{plate,cutPlate, markers,myHolesNum}
};


export default LongClipGap;